module.exports = __webpack_public_path__ + "static/media/bullock-cart.c14c6fdc.gif";